<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Erase`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_ce03b0adef__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_ce03b0adef__a)"><path d="M6.44241,32.599900000000005L14.14735,40.3871Q15.7432,42,18.0001,42L18.1799,42L39.1356,42C40.0615,42,40.8121,41.2414,40.8121,40.3056C40.8121,39.3699,40.0615,38.6113,39.1356,38.6113L28.1273,38.6113L41.5821,24.8196Q43.0072,23.3589,43,21.3076Q42.9928,19.2562,41.5576,17.8057L31.319,7.45777Q29.8766,5.9999858612,27.8368,5.999987881Q25.7969,5.999987881,24.3546,7.45777L6.44241,25.5611Q5.0000274793,27.0189,5.0000276042,29.0805Q5.0000274793,31.1422,6.44241,32.599900000000005ZM18.5689,38.6113L20.2753,38.6112L22.542,38.6112C23.1029,38.6112,23.6404,38.384,24.0342,37.9803L27.0601,34.878699999999995L14.51255,22.1972L8.813279999999999,27.9573C8.1995,28.5777,8.1995,29.5834,8.813279999999999,30.2037L16.5182,37.990899999999996C16.9112,38.3881,17.4443,38.6113,18,38.6113L18.1755,38.6113L18.1799,38.6113L18.5689,38.6113ZM16.8834,19.801000000000002L29.4142,32.465599999999995L39.1946,22.4404C39.801,21.8188,39.7975,20.8191,39.1868,20.201900000000002L28.9481,9.853950000000001C28.3343,9.23362,27.3392,9.23362,26.7254,9.853950000000001L16.8834,19.801000000000002Z" fill-rule="evenodd"/></g></svg>
</template>
<script>

export default {
  name: 'IconErase',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
